import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetHeaderComponent, AssetHeaderConfig } from '../../shared/components/asset-header/asset-header.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

export interface ResourceItem {
  id: string;
  title: string;
  description: string;
  url: string;
  /** Image path (e.g. /knowledge-hub/bluebook.png); when set, shown instead of PDF icon. */
  imagePath: string;
}

export interface StoryItem {
  id: string;
  title: string;
  description: string;
  imagePath: string;
  storyUrl: string;
}

@Component({
  selector: 'app-knowledge-hub',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    AssetHeaderComponent,
  ],
  templateUrl: './knowledge-hub.component.html',
  styleUrl: './knowledge-hub.component.scss',
})
export class KnowledgeHubComponent {
  headerConfig: AssetHeaderConfig = {
    breadcrumbs: [
      { label: 'Home', route: '/' },
      { label: 'Knowledge hub' }
    ],
    title: 'Knowledge hub',
    description: 'Browse the knowledge base and curated content. Find articles, guides, and resources to help you get the most out of MahaAgX.'
  };

  /** PDF and document resources; open in new tab. */
  readonly resources: ResourceItem[] = [
    {
      id: 'bluebook',
      title: 'MahaAgX Blue Book',
      description: 'Provides a strategic view of how a state-led data exchange can improve service delivery, policy design and long-term resilience in agriculture.',
      url: 'https://mahaagx.maharashtra.gov.in/collateral/bluebook',
      imagePath: '/knowledge-hub/bluebook.png'
    },
    {
      id: 'ai-policy',
      title: 'MahaAgri-AI Policy',
      description: 'Policy framework and implementation roadmap for transforming agriculture through Artificial Intelligence & emerging technologies',
      url: 'https://mahaagx.maharashtra.gov.in/collateral/ai-policy',
      imagePath: '/knowledge-hub/ai-policy.png'
    }
  ];

  /** Stories based on datasets; add more entries here as new stories are published. */
  readonly storiesBaseUrl = 'https://mahaagx.maharashtra.gov.in/stories';
  readonly stories: StoryItem[] = [
    {
      id: 'soil',
      title: 'Soil',
      description: 'Explore data-driven insights and visualisations on soil health and composition across Maharashtra.',
      imagePath: '/knowledge-hub/soil.png',
      storyUrl: `${this.storiesBaseUrl}/soil/`
    },
    {
      id: 'crop',
      title: 'Crop',
      description: 'Discover crop patterns, yields, and agricultural analytics powered by open datasets.',
      imagePath: '/knowledge-hub/crop.png',
      storyUrl: `${this.storiesBaseUrl}/crop/`
    }
  ];
}
